<template>
  <div v-if="typeof statuses !== 'undefined'">
    <v-subheader>Displaying last 5 modified history</v-subheader>
    <v-timeline dense class="mx-3">
      <template v-for="(status, index) in statuses">
        <v-timeline-item fill-dot color="primary" class="ma-0" :small="index !== 0" :medium="index === 0" :key="index" v-if="index < 5">
          <!--template v-slot:icon v-if="index===0">
            <v-tooltip top>
              <v-btn text icon color="white" v-on="on" @click.native="$emit('statusChange')">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <span>Edit Status</span>
            </v-tooltip>
          </template-->
          <v-layout row wrap>
            <v-flex xs6>
              <span class="body-2">Status </span>
              <div>
                <v-chip class="white--text ml-0" color="primary" label small>
                  {{ status.clmStatDesc }}
                </v-chip>
              </div>
            </v-flex>
            <v-flex xs6>
              <span class="body-2">Cause </span>
              <div>
                <v-chip class="white--text ml-0" color="primary" label small>
                  {{ status.cseStatDesc }}
                </v-chip>
              </div>
            </v-flex>
            <v-flex xs12>
              <div>
                <v-icon>mdi-account-edit</v-icon>
                <span>{{ status.usrName }}</span>
              </div>
            </v-flex>
            <v-flex xs12>
              <div>
                <v-icon>mdi-calendar-clock</v-icon>
                <span>{{ formatDateTime(status.createdDate) }}</span>
              </div>
            </v-flex>
          </v-layout>
        </v-timeline-item>
      </template>
    </v-timeline>
  </div>
</template>

<script>
import { formatDisplayDateTime } from '@/utils/date'

export default {
  computed: {
    statuses() {
      return this.$store.state.claims.claimDetail.commonInfo.claimStatuses
    }
  },
  methods: {
    formatDateTime(date) {
      return formatDisplayDateTime(date)
    }
  }
}
</script>

<style lang="scss">
</style>
